import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { FactCheck } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export function ProcedureHeader({ procedure }) {
  const { t } = useTranslation(['tasks', 'common']);

  return (
    <Box sx={{ mb: 3 }}>
      {/* Title Section */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
          <FactCheck color="primary" fontSize="large" />
          <Typography variant="h4" fontWeight={550}>
            {t('tasks:procedure.title', 'Procedure')}
          </Typography>

          <Box flex={1} />

          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 1 }}>
            <Chip
              label={`${procedure.total_steps} ${t('tasks:procedure.steps', 'steps')}`}
              size="small"
              variant="outlined"
            />
            {!procedure.is_active && (
              <Chip
                label={t('tasks:procedure.inactive', 'Inactive')}
                size="small"
                color="error"
              />
            )}
            {procedure.is_system_procedure && (
              <Chip
                label={t('tasks:procedure.system', 'System')}
                size="small"
                color="info"
                variant="outlined"
              />
            )}
          </Box>
        </Box>
      </Box>

      {/* Procedure Details */}
      <Box>
        <Typography variant="subtitle1" fontWeight="bold">
          {procedure.name}
        </Typography>
        {procedure.description && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {procedure.description}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
